import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export class Badge extends AuxiliumComponent {
	static observedAttributes = ["variation"];

	constructor() {
		super();

		this.variation = this.getAttribute("variation") ?? "theme";
		this.size = this.getAttribute("size");
		this.icon = this.getAttribute("icon");
		this.link = this.getAttribute("link") ?? "";
		this.badgeStyle = this.getAttribute("badge-style");
	}

	parsedCallback() {
		if (this.link) { this.appendChild(document.createElementWithContents("chip-link", this.childNodes, { href: Browser.ResolveRelativeURL(this.link) })); }

		this.classList.add("badge", `badge--${this.variation}`);

		if (this.size) { this.classList.add(`badge--${this.size.toLowerCase()}`); }
		if (this.icon) { this.prepend(document.createElementWithContents("chip-icon", null, { icon: this.icon })); }
	}

	SetText(text) {
		this.textContent = text;
		if (this.icon) { this.prepend(document.createElementWithContents("chip-icon", null, { icon: this.icon })); }
	}

	attributeChanged(name, oldValue, newValue) {
		if (name === "variation") {
			this.classList.remove(`badge--${oldValue}`);
			this.classList.add(`badge--${newValue}`);
		}
	}
}